/* The catalogue's only script.
 *
 * Everything here is an UPGRADE. Filters submit, sorting submits, variants are
 * a real <select>, the cart is a form. If this file fails to load the shop
 * still works — it just reloads the page more often. That is deliberate: a
 * store that cannot take an order because a script broke is a store that is
 * shut.
 */
(() => {
  'use strict';

  /* ---- sort dropdowns submit themselves ---- */
  document.querySelectorAll('select[data-auto-submit]').forEach((el) => {
    el.addEventListener('change', () => el.form && el.form.submit());
  });

  /* ---- filters apply as you tick them ----
     Submitting the form is what actually applies the filter; the only thing
     added here is not having to find a button afterwards. Price inputs wait
     until you stop typing. */
  const facets = document.querySelector('[data-facets]');
  if (facets) {
    let timer;
    facets.addEventListener('change', (e) => {
      if (e.target.type === 'number') return;
      facets.submit();
    });
    facets.addEventListener('input', (e) => {
      if (e.target.type !== 'number') return;
      clearTimeout(timer);
      timer = setTimeout(() => facets.submit(), 700);
    });
  }

  /* ---- product gallery ---- */
  const main = document.getElementById('prod-main');
  if (main) {
    document.querySelectorAll('[data-thumb]').forEach((btn) => {
      btn.addEventListener('click', () => {
        main.src = btn.dataset.thumb;
        document.querySelectorAll('[data-thumb]').forEach((b) => b.removeAttribute('aria-current'));
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---- variant picking ----
     The option dropdowns are a friendlier face on one hidden variant id. Every
     combination is matched against the real variant list, so an unavailable
     combination disables the button rather than failing at the cart. */
  const form = document.querySelector('[data-add-form]');
  const raw = document.querySelector('[data-variants]');
  if (form && raw) {
    let variants = [];
    try { variants = JSON.parse(raw.textContent); } catch { return; }

    const idField = form.querySelector('[data-variant-id]');
    const selects = [...form.querySelectorAll('[data-option-index]')];
    const btn = form.querySelector('[data-add-btn]');
    const priceEl = document.querySelector('[data-price]');
    const stockEl = document.querySelector('[data-stock]');
    if (!selects.length) return;

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US',
          { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
      } catch { return '$' + (cents / 100).toFixed(2); }
    };

    const sync = () => {
      const chosen = selects.map((s) => s.value);
      const match = variants.find((v) =>
        chosen.every((val, i) => (v.options ? v.options[i] : v['option' + (i + 1)]) === val));

      if (!match) {
        btn.disabled = true;
        btn.textContent = 'Not available';
        if (stockEl) stockEl.textContent = 'That combination is not available. Try a different one.';
        return;
      }

      idField.value = match.id;
      btn.disabled = !match.available;
      btn.textContent = match.available ? 'Add to cart' : 'Sold out';
      if (priceEl) priceEl.innerHTML = '<span class="price">' + money(match.price) + '</span>';
      if (stockEl && match.available) stockEl.textContent = stockEl.dataset.inStock || stockEl.textContent;

      /* keep the address bar honest, so a copied link opens the same choice */
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    };

    selects.forEach((s) => s.addEventListener('change', sync));
    sync();
  }

  /* ---- "forgotten your password" opens without a jump ---- */
  const recover = document.querySelector('.auth__recover');
  const recoverLink = document.querySelector('a[href$="/account/login#recover"], a[href$="recover"]');
  if (recover && recoverLink) {
    recoverLink.addEventListener('click', (e) => {
      e.preventDefault();
      recover.classList.add('is-open');
      recover.querySelector('input')?.focus();
    });
  }
})();
